import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button,
  ModalBody,
  ModalCloseButton,
  ModalFooter,
  ModalHeader,
  Radio,
  RadioGroup,
  Stack,
  Text,
  VStack,
} from '@chakra-ui/react';
import { shippingOptionType, STEPS } from './AddressModal';

interface IProps {
  shippingOptionType: shippingOptionType;
  setStep(step: STEPS): void;
  onCancel: () => void;
  loading: boolean;
}

export default ({
  loading,
  onCancel,
  setStep,
  shippingOptionType,
}: IProps): React.ReactElement => {
  const { t } = useTranslation();
  const [option, setOption] = React.useState<string>(
    shippingOptionType || 'ship',
  );

  const handleNext = () => {
    if (option === 'ship') {
      setStep('LIST');
    } else {
      setStep('CHOOSE_LOCAL_PICKUP');
    }
  };
  return (
    <>
      <ModalHeader>{t('subscription.delivery_method')}</ModalHeader>
      <ModalCloseButton />
      <ModalBody>
        <VStack
          spacing={3}
          alignItems="flex-start"
          className="bundleapp-flex bundleapp-flex-align-center"
        >
          <Text fontSize="md">{t('subscription.choose_delivery')}</Text>
          <RadioGroup
            defaultValue={shippingOptionType}
            name="shipping-option"
            onChange={(value) => setOption(value)}
          >
            <Stack spacing={3}>
              <Radio size="md" name="ship" value="ship">
                {t('subscription.ship')}
              </Radio>
              <Radio size="md" name="pick-up" value="pick-up">
                {t('subscription.pick_up')}
              </Radio>
            </Stack>
          </RadioGroup>
        </VStack>
      </ModalBody>
      <ModalFooter>
        <Button mr="4" onClick={onCancel} variant="outlinedBig">
          {t('titles.cancel')}
        </Button>
        <Button
          onClick={handleNext}
          isLoading={loading}
          disabled={loading}
          variant="blackBig"
        >
          {t('titles.save')}
        </Button>
      </ModalFooter>
    </>
  );
};
